module.exports = __webpack_public_path__ + "img/20191213164824025.198ccfc4.jpg";